import { ErrorMessageComponent } from "@/features/api/domain/ErrorMessageComponent";
import { Text } from "@meditect/medibase-components";

export const RolesCannotDeleteOwnerRoleError: ErrorMessageComponent<Record<string, never>> = () => {
  return (
    <Text as="span" mr={1}>
      Ce rôle est le rôle Titulaire de la pharmacie et ne peut jamais être supprimé, afin de garantir que la pharmacie
      garde toujours un moyen de s’auto-administrer.
    </Text>
  );
};
